// extracted by mini-css-extract-plugin
module.exports = {"container-inactividad":"Inactividad_container-inactividad__CduPQ","inactividad-info":"Inactividad_inactividad-info__q5nR8"};